"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const rum_1 = require("@yandex-int/pythia-libs/lib/rum");
const actions_1 = require("src/redux/actions");
const settings_1 = require("src/hooks/settings");
const question_text_1 = __importDefault(require("src/components/question-text"));
const question_choice_1 = __importDefault(require("src/components/question-choice"));
const question_rating_1 = __importDefault(require("src/components/question-rating"));
const question_emotion_1 = __importDefault(require("src/components/question-emotion"));
const question_scale_1 = __importDefault(require("src/components/question-scale"));
const question_sidebyside_1 = __importDefault(require("src/components/question-sidebyside"));
const question_geo_text_1 = __importDefault(require("src/components/question-geo-text"));
const question_table_1 = __importDefault(require("src/components/question-table"));
const question_image_clickmap_1 = __importDefault(require("src/components/question-image-clickmap"));
const question_video_1 = __importDefault(require("src/components/question-video"));
const widget_markup_1 = __importDefault(require("src/components/widget-markup"));
const question_table_scale_1 = __importDefault(require("src/components/question-table-scale"));
const modal_1 = require("src/context/modal");
const frame_1 = require("src/utils/frame");
const page_styles_1 = __importDefault(require("./page.styles"));
const b = b_1.default.with('page');
const QUESTION_COMPONENTS = {
    longText: question_text_1.default,
    shortText: question_text_1.default,
    email: question_text_1.default,
    number: question_text_1.default,
    choice: question_choice_1.default,
    rating: question_rating_1.default,
    scale: question_scale_1.default,
    emotion: question_emotion_1.default,
    sidebyside: question_sidebyside_1.default,
    geoText: question_geo_text_1.default,
    ux: question_image_clickmap_1.default,
    date: question_text_1.default,
    table: question_table_1.default,
    clickmapVideo: question_video_1.default,
    tableScale: question_table_scale_1.default
};
const WIDGET_COMPONENTS = {
    markup: widget_markup_1.default,
    video: widget_markup_1.default
};
const PageWidget = (_a) => {
    var { key } = _a, widget = __rest(_a, ["key"]);
    const { displayHiddenQuestions } = (0, modal_1.useModalContext)();
    if (!widget.visible && !displayHiddenQuestions) {
        return null;
    }
    const WidgetComponent = WIDGET_COMPONENTS[widget.type];
    return WidgetComponent && (0, jsx_runtime_1.jsx)(WidgetComponent, Object.assign({}, widget), key);
};
// eslint-disable-next-line max-statements, complexity
const PageQuestion = (_a) => {
    var { key, theme, lang } = _a, question = __rest(_a, ["key", "theme", "lang"]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const nextBtnBehavior = (0, settings_1.useNextBtnBehaviour)();
    const charLimits = (0, settings_1.useCharLimits)();
    const options = { nextBtnBehavior, charLimits };
    const { displayHiddenQuestions, feedbackDemoMode } = (0, modal_1.useModalContext)();
    if (!question.visible && !displayHiddenQuestions) {
        return null;
    }
    question.questionIndex = question.id;
    switch (question.type) {
        case 'table': {
            question.handleClickOption = (questionIndex, boundQIndex, optionIndex) => {
                dispatch((0, actions_1.clickOptionQuestion)(boundQIndex, optionIndex));
                dispatch((0, actions_1.clickTableOptionQuestion)(questionIndex, boundQIndex, optionIndex));
            };
            break;
        }
        case 'tableScale': {
            question.handleClickOption = (questionIndex, boundQIndex, optionIndex) => {
                dispatch((0, actions_1.clickOptionQuestion)(boundQIndex, optionIndex));
                dispatch((0, actions_1.clickTableOptionQuestion)(questionIndex, boundQIndex, optionIndex));
            };
            question.handleClickNoOpinionAnswer = (questionIndex, boundQIndex, optionIndex) => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(boundQIndex));
                dispatch((0, actions_1.clickTableOptionQuestion)(questionIndex, boundQIndex, optionIndex));
            };
            break;
        }
        case 'choice': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.target.value));
            };
            question.handleClickOther = () => {
                dispatch((0, actions_1.clickOtherQuestion)(question.id));
            };
            question.handleClickOtherWithText = () => {
                dispatch((0, actions_1.clickOtherWithTextQuestion)(question.id));
            };
            question.handleChangeOtherWithText = e => {
                let input = e.target.value;
                if (charLimits.disableOverflow && charLimits.answerWithText) {
                    input = input.slice(0, charLimits.answerWithText);
                }
                dispatch((0, actions_1.changeOtherWithTextQuestion)(question.id, input, options));
            };
            question.handleBlurOtherWithText = e => {
                dispatch((0, actions_1.blurQuestionText)(question.id, e.target.value, options));
            };
            question.handleClickNoAnswer = () => {
                dispatch((0, actions_1.clickNoAnswerQuestion)(question.id));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            break;
        }
        case 'scale': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.currentTarget.dataset.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            question.handleClickOther = () => {
                dispatch((0, actions_1.clickOtherQuestion)(question.id));
            };
            question.handleChangeOtherWithText = e => {
                dispatch((0, actions_1.changeOtherWithTextQuestion)(question.id, e.target.value, options));
            };
            question.handleClickOtherWithText = () => {
                dispatch((0, actions_1.clickOtherWithTextQuestion)(question.id));
            };
            question.handleBlurOtherWithText = e => {
                dispatch((0, actions_1.blurQuestionText)(question.id, e.target.value, options));
            };
            question.feedbackDemoMode = feedbackDemoMode;
            break;
        }
        case 'rating': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.target.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            question.handleClickOther = () => {
                dispatch((0, actions_1.clickOtherQuestion)(question.id));
            };
            question.handleChangeOtherWithText = e => {
                dispatch((0, actions_1.changeOtherWithTextQuestion)(question.id, e.target.value, options));
            };
            question.handleClickOtherWithText = () => {
                dispatch((0, actions_1.clickOtherWithTextQuestion)(question.id));
            };
            question.handleBlurOtherWithText = e => {
                dispatch((0, actions_1.blurQuestionText)(question.id, e.target.value, options));
            };
            break;
        }
        case 'emotion': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.currentTarget.dataset.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            question.handleClickOther = () => {
                dispatch((0, actions_1.clickOtherQuestion)(question.id));
            };
            question.handleChangeOtherWithText = e => {
                dispatch((0, actions_1.changeOtherWithTextQuestion)(question.id, e.target.value, options));
            };
            question.handleClickOtherWithText = () => {
                dispatch((0, actions_1.clickOtherWithTextQuestion)(question.id));
            };
            question.handleBlurOtherWithText = e => {
                dispatch((0, actions_1.blurQuestionText)(question.id, e.target.value, options));
            };
            question.feedbackDemoMode = feedbackDemoMode;
            break;
        }
        case 'date':
        case 'longText':
        case 'shortText':
        case 'email':
        case 'number': {
            question.handleBlur = e => {
                const text = e.target.value;
                dispatch((0, actions_1.blurQuestionText)(question.id, text, options));
            };
            question.handleChange = e => {
                let text = e.target.value;
                if (charLimits.disableOverflow && charLimits[question.type]) {
                    text = text.slice(0, charLimits[question.type]);
                }
                dispatch((0, actions_1.changeQuestionText)(question.id, text, options));
            };
            break;
        }
        case 'clickmapVideo': {
            question.handleEnd = e => {
                dispatch((0, actions_1.endVideoQuestion)(question.id, e));
            };
            break;
        }
        case 'ux': {
            question.handleClick = clickEvent => {
                dispatch((0, actions_1.clickImageQuestionClickmap)(question.id, clickEvent));
            };
            question.handleLoadImage = loadEvent => {
                dispatch((0, actions_1.drawImageQuestionClickmap)(question.id, loadEvent));
            };
            break;
        }
        case 'sidebyside': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.target.dataset.value || e.target.parentNode.dataset.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            question.handleClickNoAnswer = () => {
                dispatch((0, actions_1.clickNoAnswerQuestion)(question.id));
                if (theme === 'ugc-cab') {
                    dispatch((0, actions_1.clickNextPage)());
                }
            };
            break;
        }
        case 'geoText': {
            question.handleSelect = ({ index, value }) => {
                value = value.trim();
                dispatch((0, actions_1.changeQuestionText)(index, value, options));
                dispatch((0, actions_1.blurQuestionText)(index, value, options));
            };
            question.handleBlur = e => {
                const text = e.target.value.trim();
                dispatch((0, actions_1.blurQuestionText)(question.id, text, options));
            };
            question.handleChange = e => {
                const text = e.target.value.trim();
                dispatch((0, actions_1.changeQuestionText)(question.id, text, options));
            };
            break;
        }
        default: {
            break;
        }
    }
    const QuestionComponent = QUESTION_COMPONENTS[question.type];
    return (QuestionComponent && (0, jsx_runtime_1.jsx)(QuestionComponent, Object.assign({}, question, { theme: theme, lang: lang }), key));
};
function PageGroup(group) {
    const { type, children } = group;
    if (type === 'transparent') {
        return children.map(child => (0, jsx_runtime_1.jsx)(PageChild, { child: child }, `${child.id}-${child.type}`));
    }
    return null;
}
// eslint-disable-next-line max-statements, complexity
function PageChild({ child, questions, widgets, groups, theme, lang, showScreeningLabel }) {
    switch (child.type) {
        case 'question': {
            const question = questions[child.id];
            const props = Object.assign(Object.assign({}, question), { theme,
                lang,
                showScreeningLabel, key: `${child.type}-${child.id}`, errors: (question.errorVisible && question.errors) || [] });
            if (question.type === 'table') {
                const boundQuestionsRevision = {};
                question.boundQuestions.forEach(q => {
                    boundQuestionsRevision[q] = questions[q];
                });
                question.boundQuestionsRevision = boundQuestionsRevision;
            }
            return PageQuestion(props);
        }
        case 'widget': {
            const widget = widgets[child.id];
            const props = Object.assign(Object.assign({}, widget), { key: `${child.type}-${child.id}` });
            return PageWidget(props);
        }
        case 'group': {
            const group = groups[child.id];
            const props = Object.assign(Object.assign({}, group), { key: child.id });
            return PageGroup(props);
        }
        default:
            return null;
    }
}
// eslint-disable-next-line complexity
const Page = props => {
    const { children, questions, widgets, groups, theme, lang, displayMode, mode, nextPageIndex, nextBtnLabel, pageNumber, isCurrentPageUxAnswered, renderVendorLabel, renderNextButton, isScreening, isDemoModeWithHeader, isEmbedded } = props;
    const inFrame = (0, frame_1.isInIframe)();
    (0, react_2.useEffect)(() => {
        if (process.env.NODE_ENV !== 'storybook' && window.Ya.Rum.sendHeroElement) {
            (0, rum_1.sendFirstMeaningfulPaint)();
        }
    }, []);
    const childrenVisible = (0, react_2.useMemo)(() => {
        if (!isCurrentPageUxAnswered && theme === 'ux') {
            return children.filter(child => {
                // показываем только UX-вопрос со страницы, пока на него не ответили
                return child.type !== 'question' || questions[child.id].type === 'ux';
            });
        }
        return children;
    }, [isCurrentPageUxAnswered, theme, children, questions]);
    const isPageContentWide = Object.keys(questions).some(qId => questions[qId].imageAlign);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b({
            theme,
            'display-mode': displayMode,
            wide: isPageContentWide ? 'yes' : 'no',
            mode,
            first: pageNumber === 0 ? 'yes' : 'no',
            last: nextPageIndex === -1 ? 'yes' : 'no',
            embedded: isEmbedded && inFrame && (childrenVisible === null || childrenVisible === void 0 ? void 0 : childrenVisible.length) ? 'yes' : 'no'
        }) }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: page_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('questions') }, { children: childrenVisible.map(c => {
                    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('component') }, { children: (0, jsx_runtime_1.jsx)(PageChild, { child: c, questions: questions, widgets: widgets, groups: groups, theme: theme, lang: lang, showScreeningLabel: isScreening && isDemoModeWithHeader }, `${c.id}-${c.type}`) }), `${c.id}-${c.type}`));
                }) })), renderVendorLabel(), renderNextButton({ label: nextBtnLabel })] })));
};
Page.defaultProps = {
    children: [],
    pageNumber: 0,
    questions: {},
    widgets: {},
    groups: {},
    lang: 'ru',
    theme: 'default',
    displayMode: 'default',
    mode: '',
    nextPageIndex: 1,
    showScreeningLabel: false
};
exports.default = Page;
